import HttpService from '../baseHttp'
// dictionary
// 数据字典接口
export const HttpProductList = (data = {}) => HttpService.get('/api/v1/ProductLine/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 全部项目（包含已关闭，已停用的）,区分组织
export const HttpAllProductList = (data = {}) => HttpService.get('/api/v1/ProductLine/findAllByContextIdBesideFlag', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpAccountList = (data = {}) => HttpService.get('/api/v1/Account/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpAllaccountType = (data = {}) => HttpService.get('/api/v1/ChannelCategory/findAllByType', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// /api/v1/ChannelCategory/findAllByType

export const HttpWarehouseList = (data = {}) => HttpService.get('/api/v1/OrganizationWarehouse/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpProductErpSku = (data = {}, config) => HttpService.get('/api/v1/Product/findByErpSku', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpVsGroups = (data = {}, config) => HttpService.get('/api/v2/StockVirtualGroupRule/rule/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpPersonInfoList = (data, config) => HttpService.get('api/v1/User/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })

export const HttpUserList = (data, config) => HttpService.get('api/v1/User/findAllByContextId', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
// 全部平台发运方式的获取
export const HttpPlatform = (data, config) => HttpService.get('/api/v2/AccountSiteShipping/findAll', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取国家列表
export const HttpGetContry = (data = {}, config) => HttpService.get('/api/v1/commonRegion/getCommonRegion', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 获取系统发运方式的下拉列表
export const SystemDelivery = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectSystemDeliveryCarriers', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 新列表
export const NewSystemDelivery = (data = {}, config) => HttpService.get('/api/v2/sysCarrierService/findList', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })


// 系统发运方式列表
export const SystemWarehouse = (data = {}, config) => HttpService.get('/api/v2/warehouse/findAllWarehouses', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 组织仓库发运方式列表
export const OrgWarehouse = (data = {}, config) => HttpService.get('/api/v2/organizationWarehouse/findOrgWarehousesByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 系统发运方式弹框的三个下拉列表
// shoppingcode、carrier、service
export const SystemShippingCode = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectCarrierServiceCodes', { params: data,
baseURL: process.env.VUE_APP_APIURL_FBB })
export const SystemCarrier = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectCarrierCodes', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 新接口
export const NewSystemCarrier = (data = {}, config) => HttpService.get('/api/v2/sysCarrier/findList', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })


export const SystemService = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectCarrierServiceNames', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 新接口
// export const NewSystemService = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectCarrierServiceNames', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })


// 通过仓库id，获取仓库地址信息
export const HttpAllotAddress = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/findByOrgIdAndCode', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS  })

// 获取店铺名称、渠道名称
export const HttpAccountType = (data = {}, config) => HttpService.get('/api/v1/ChannelCategory/findAll', { params: data })

export const HttpAccountAllList = (data = {}) => HttpService.get('/api/v1/Account/findAllByOrgIdInAndIdIn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpProductLineAllList = (data = {}) => HttpService.get('/api/v1/ProductLine/findAllByOrgIdInAndIdIn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpWarehouseAllList = (data = {}) => HttpService.get('/api/v1/OrganizationWarehouse/findAllByOrgIdInAndIdIn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpTaskServiceList = (data = {}) => HttpService.get('/api/v1/TaskCenter/findService', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })




